/// Auto-generated with ScanbotSDKCodegenV3. Modifications will be overwritten.
/// Generated from core/schemas/ObjectPoolTypes.yaml

import { ToJsonConfiguration } from '../utils/json/JsonSerializationTypes';
import type { DeepPartial } from '../utils/utils';
import { PartiallyConstructible } from '../utils/utils';

/**
Profile info of a reference-counted stored object.
*/
export class RefCountedObjectProfile extends PartiallyConstructible {
  /**
    Unique ID of the object.
    */
  public readonly uniqueId: string;
  /**
    Timestamp (milliseconds since the UNIX epoch), at which the object was first created.
    */
  public readonly timestampCreated: number;
  /**
    Number of strong references associated with the object. The strong reference count increases when a new instance of a platform ImageRef class is created from the object's unique ID and decreases when the ImageRef instance is destroyed.
    
    Default is 0
    */
  public readonly strongReferences: number = 0;
  /**
    Number of serialized references to the object. The serialized reference count increases when an ImageRef is written to JSON or a Parcel on Android and decrease when the respective JSON or Parcel is deserialized.
    
    Default is 0
    */
  public readonly serializedReferences: number = 0;

  /** @param source {@displayType `DeepPartial<RefCountedObjectProfile>`} */
  public constructor(source: DeepPartial<RefCountedObjectProfile> = {}) {
    super();
    if (source.uniqueId !== undefined) {
      this.uniqueId = source.uniqueId;
    } else {
      throw new Error('uniqueId must be present in constructor argument');
    }
    if (source.timestampCreated !== undefined) {
      this.timestampCreated = source.timestampCreated;
    } else {
      throw new Error('timestampCreated must be present in constructor argument');
    }
    if (source.strongReferences !== undefined) {
      this.strongReferences = source.strongReferences;
    }
    if (source.serializedReferences !== undefined) {
      this.serializedReferences = source.serializedReferences;
    }
  }

  public serialize(config: ToJsonConfiguration = new ToJsonConfiguration()): DeepPartial<RefCountedObjectProfile> {
    return {
      uniqueId: this.uniqueId,
      timestampCreated: this.timestampCreated,
      strongReferences: this.strongReferences,
      serializedReferences: this.serializedReferences,
    };
  }
}
